import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { ReportingService } from 'src/app/services/reporting/reporting.service';
import { ResponseTimeService } from 'src/app/services/general/response-time.service';
import { ICallOverview } from 'src/app/interfaces/icall-overview';
import { NavigationEnd, Router } from '@angular/router';
import { CallGuidedDetailsSidePanelComponent } from '../call-guided-details-side-panel/call-guided-details-side-panel.component';
import { AppConstants } from 'src/app/app-constants';
import { CallConversationalDetailsSidePanelComponent } from '../call-conversational-details-side-panel/call-conversational-details-side-panel.component';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';


@Component({
  selector: 'app-content-call-overview',
  templateUrl: './content-call-overview.component.html',
  styleUrls: ['./content-call-overview.component.scss'],
  standalone: false
})
export class ContentCallOverviewComponent {
  @Input() accountUuid: string = '';
  @Input() moduleUuid: string = '';
  @Input() moduleName: string = '';
  allCallOverview: ICallOverview[] = [];
  isAllCallOverviewLoading: boolean = true;
  isSidePaneVisible: boolean = false;
  selectedCall: ICallOverview | undefined;

  constructor(
    private reportingService: ReportingService,
    private gaService: GoogleAnalyticsService,
    private responseTimeService: ResponseTimeService,
    private router: Router,
    private dialog: MatDialog,
    private amplitudeService: AmplitudeService,
  ) { }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.gaService.trackPageView(event.urlAfterRedirects);
      }
    });
    this.getCallsWithOverviewByModule();
  }

  toggleSidePane(call: ICallOverview): void {
    // Sending the Event of Clicking on Call Details to Amplitude
    this.amplitudeService.trackEvent('modulereport_click_calldetails', {
      'call_name': call?.callName,
    });

    if (call.callType === AppConstants.CALL_TYPE_CONVERSATIONAL) {
      this.dialog.open(CallConversationalDetailsSidePanelComponent, {
        hasBackdrop: true,
        disableClose: true,
        position: { right: '0', top: '0' },
        width: '720px',
        data: {
          accountUuid: this.accountUuid,
          moduleName: this.moduleName,
          moduleUuid: this.moduleUuid,
          call: call,
        },
      });

    } else if (call.callType === AppConstants.CALL_TYPE_GUIDED) {
      this.dialog.open(CallGuidedDetailsSidePanelComponent, {
        hasBackdrop: true,
        disableClose: true,
        position: { right: '0', top: '0' },
        data: {
          accountUuid: this.accountUuid,
          moduleName: this.moduleName,
          moduleUuid: this.moduleUuid,
          call: call,
        },
      });
    }
  }

  closeSidePane(): void {
    this.isSidePaneVisible = false;
  }
  getCallsWithOverviewByModule() {
    this.responseTimeService
      .logResponseTime(
        this.reportingService.getCallsWithOverviewByModule(this.accountUuid, this.moduleUuid),
        'getCallsWithOverviewByModule'
      )
      .subscribe({
        next: (res: ICallOverview[]) => {
          this.isAllCallOverviewLoading = false;
          this.allCallOverview = res;
        },
        error: (error) => {
          this.isAllCallOverviewLoading = false;
          console.error('Error fetching calls with overview', error);
        },
      });
  }
}
